"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigNames = exports.CommonStrings = void 0;
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
const localizeUtils_1 = require("../../../common/localizeUtils");
class CommonStrings {
}
exports.CommonStrings = CommonStrings;
CommonStrings.APP_STUDIO_BOT_REGISTRATION = (0, localizeUtils_1.getLocalizedString)("plugins.bot.AppStudioBotRegistration");
class ConfigNames {
}
exports.ConfigNames = ConfigNames;
ConfigNames.APPSTUDIO_TOKEN = "app studio token";
ConfigNames.MESSAGE_ENDPOINT = "message endpoint";
//# sourceMappingURL=strings.js.map